<div class="p-2">

  <!-- winepassport#362 (WP-016) — buscador y filtros en la misma columna (a la derecha de la
       flecha "volver"), así quedan alineados en escritorio. -->
  <div class="p-1 w-full flex items-end">
    <div class="hidden md:flex mr-3 mb-3">
      <button (click)="goBack()">
        <app-metro-icon [svg]="iconBack" size="20" color="#0e161b"></app-metro-icon>
      </button>
    </div>

    <div class="flex-1 flex flex-col items-center min-w-0">
      <div #searchBox class="relative w-full md:w-1/2">
        <app-metro-search-input [placeholder]="'::Catalog:SearchPlaceholder' | abpLocalization"
          (search)="onSearch($event)" (cleared)="onClearSearch()"></app-metro-search-input>
        @if (matchPreview.length) {
        <div class="absolute left-0 right-0 z-30 -mt-1 bg-white border border-gray-200 rounded-lg shadow-lg py-1 font-sans">
          <p class="px-3 pt-1 pb-1 text-[11px] text-gray-400">{{ '::Catalog:SuggestionsHeader' | abpLocalization }}</p>
          @for (match of matchPreview; track match.id) {
          <button type="button" (click)="openWine(match)"
            class="w-full text-left px-3 py-2 min-h-[44px] hover:bg-gray-50 flex flex-col">
            <span class="text-sm text-metro-black truncate">{{ match.name }}</span>
            <span class="text-xs text-gray-500 truncate">{{ match.wineryName }}{{ match.varietal ? ' · ' + match.varietal : '' }}</span>
          </button>
          }
        </div>
        }
      </div>

      <!-- winepassport#398 — en mobile 3 filtros en una fila y el orden pasa al encabezado de Vinos -->
      <div class="w-full md:w-1/2 grid grid-cols-3 gap-x-1.5 md:flex md:gap-1 md:justify-center min-w-0">
        <app-metro-form-select [size]="'sm'" [placeholder]='"::Country" | abpLocalization' [options]="countryOptions"
          [(ngModel)]="selectedCountry" (selectionChange)="onCountryChange($event)" [allowSearch]="false"
          selectedBackgroundClass="bg-metro-secondary" class="md:flex-1 min-w-0"></app-metro-form-select>

        <app-metro-form-select [size]="'sm'" [placeholder]='"::Region" | abpLocalization' [options]="regionOptions"
          [(ngModel)]="selectedRegion" (selectionChange)="onRegionChange($event)" [allowSearch]="false"
          selectedBackgroundClass="bg-metro-secondary" class="md:flex-1 min-w-0 max-md:[&_ul]:left-1/2 max-md:[&_ul]:-translate-x-1/2"></app-metro-form-select>

        <app-metro-form-select [size]="'sm'" [placeholder]='"::Winery" | abpLocalization' [options]="wineryOptions"
          [(ngModel)]="selectedWinery" (selectionChange)="onWineryChange($event)" [allowSearch]="false"
          selectedBackgroundClass="bg-metro-secondary" class="md:flex-1 min-w-0 max-md:[&_ul]:left-auto max-md:[&_ul]:right-0"></app-metro-form-select>

        <!-- winepassport#363 (WP-017) -->
        <app-metro-form-select [size]="'sm'" [placeholder]='"::Catalog:Sort:Label" | abpLocalization' [options]="sortOptions"
          [(ngModel)]="selectedSort" (selectionChange)="onSortChange($event)" [allowSearch]="false"
          selectedBackgroundClass="bg-metro-secondary" class="hidden md:block md:flex-1 min-w-0"></app-metro-form-select>
      </div>
    </div>
  </div>



  <div class="p-1 flex items-center justify-between gap-2">
    <h2 class="text-lg font-semibold">{{'::Wines' | abpLocalization}}</h2>
    <!-- winepassport#398 — orden solo en mobile, a la derecha de Vinos -->
    <div class="md:hidden relative" data-sort-menu>
      <button type="button" (click)="sortMenuOpen = !sortMenuOpen"
        class="min-h-[44px] flex items-center gap-1 text-sm text-metro-black">
        <span class="text-gray-500">{{ '::Catalog:Sort:Label' | abpLocalization }}</span>
        <span class="font-semibold">{{ selectedSortLabel }}</span>
      </button>
      @if (sortMenuOpen) {
      <ul class="absolute right-0 top-full z-20 w-52 list-none m-0 p-1 bg-white border border-gray-200 rounded-lg shadow-lg">
        @if (defaultSortLabel) {
        <li class="m-0">
          <button type="button" (click)="pickSort('')"
            class="w-full text-left px-3 min-h-[44px] rounded text-sm hover:bg-gray-50"
            [class.font-semibold]="!selectedSort">{{ defaultSortLabel }}</button>
        </li>
        }
        @for (opt of sortOptions; track opt.value) {
        <li class="m-0">
          <button type="button" (click)="pickSort(opt.value)"
            class="w-full text-left px-3 min-h-[44px] rounded text-sm hover:bg-gray-50"
            [class.font-semibold]="opt.value === selectedSort">{{ opt.label }}</button>
        </li>
        }
      </ul>
      }
    </div>
  </div>

  <div class="grid
           grid-cols-1
           gap-1
           sm:grid-cols-2 sm:gap-2
           lg:grid-cols-3 lg:gap-2
           xl:grid-cols-4 xl:gap-2
           items-stretch">

    @for (wine of wines; track $index) {
    @if (wine) {
    <app-metro-product-card [id]="wine.id" [name]="getWineDisplayData(wine).name" [year]="getWineDisplayData(wine).year"
      [stock]="getWineDisplayData(wine).stock" [maxOrder]="getWineDisplayData(wine).maxOrder"
      [location]="getWineDisplayData(wine).location" [price]="getWineDisplayData(wine).price"
      [imageUrl]="getWineDisplayData(wine).imageUrl">
    </app-metro-product-card>
    }
    }
    @if (loading || loadingMore) {
    @for (skeleton of skeletonCards; track $index) {
      <div aria-hidden="true"
        class="border rounded-lg overflow-hidden flex items-start p-2 gap-2 w-full h-full bg-white shadow-none">
        <div class="flex-1 flex flex-col min-w-0">
          <div class="space-y-1">
            <div class="skeleton-loader h-5 md:h-6 w-10/12"></div>
            <div class="skeleton-loader h-3 w-6/12"></div>
          </div>
          <div class="text-xs flex items-center gap-2 mt-2">
            <div class="skeleton-loader h-3 w-3 rounded-full"></div>
            <div class="skeleton-loader h-3 w-16"></div>
          </div>
          <div class="mt-auto flex flex-col gap-1">
            <div class="skeleton-loader h-3 w-20"></div>
            <div class="skeleton-loader h-8 w-16"></div>
          </div>
        </div>
        <div class="flex-shrink-0 ml-4 h-full flex items-center justify-center">
          <div class="w-28 h-28 flex items-center justify-center">
            <div class="skeleton-loader w-full h-full rounded object-contain"></div>
          </div>
        </div>
      </div>
    }
    }
  </div>

  <div #infiniteScrollTrigger class="w-full h-1"></div>
 

  @if (!loadingMore && !loadError && !hasMoreData && wines.length > 0) {
  <div class="text-center py-4 text-metro-blue-secondary">
    {{'::NoMoreWinesToLoad' | abpLocalization}}
  </div>
  }

  <!-- winepassport#362 — un error de red/API no se muestra como "sin resultados" -->
  @if (loadError && !loadingMore) {
  <div class="text-center py-4 text-metro-blue-secondary">
    <p>{{ '::Catalog:LoadError' | abpLocalization }}</p>
    <button type="button" (click)="retryLoad()" class="mt-2 min-h-[44px] px-4 font-semibold underline">
      {{ '::Catalog:Retry' | abpLocalization }}
    </button>
  </div>
  }

  @if (!loading && !loadingMore && !loadError && wines.length === 0) {
  @if (activeKeyword) {
  <!-- winepassport#362 — sin resultados: mensaje + "Te pueden interesar" en vez de pantalla vacía -->
  <div class="text-center py-4 text-metro-blue-secondary">
    {{ '::Catalog:NoResultsFor' | abpLocalization: activeKeyword }}
  </div>
  @if (loadingSuggestions) {
  <p class="text-center text-sm text-gray-500 pb-2">{{ '::Catalog:LoadingSuggestions' | abpLocalization }}</p>
  }
  @if (suggestions.length) {
  <div class="p-1">
    <h3 class="text-base font-semibold">{{ '::Catalog:SuggestionsTitle' | abpLocalization }}</h3>
  </div>
  <div class="grid grid-cols-1 gap-1 sm:grid-cols-2 sm:gap-2 lg:grid-cols-3 lg:gap-2 xl:grid-cols-4 xl:gap-2 items-stretch">
    @for (wine of suggestions; track wine.id) {
    <app-metro-product-card [id]="wine.id" [name]="getWineDisplayData(wine).name" [year]="getWineDisplayData(wine).year"
      [stock]="getWineDisplayData(wine).stock" [maxOrder]="getWineDisplayData(wine).maxOrder"
      [location]="getWineDisplayData(wine).location" [price]="getWineDisplayData(wine).price"
      [imageUrl]="getWineDisplayData(wine).imageUrl">
    </app-metro-product-card>
    }
  </div>
  }
  } @else {
  <div class="text-center py-4 text-metro-blue-secondary">
    {{'::NoWinesFound' | abpLocalization}}
  </div>
  }
  }
</div>
@if (whatsAppHref) {
<a [attr.href]="whatsAppHref" target="_blank" rel="noopener noreferrer" class="no-underline fixed right-6 bg-green-500 text-white w-16 h-16 rounded-full
            flex items-center justify-center shadow-lg hover:bg-green-600 transition z-50 bottom-[calc(env(safe-area-inset-bottom)+5rem)]">
  <span class=" inline-block" [innerHTML]="safeWaIcon"></span>
</a>
}